import {VIO_INTERMEDIARY_PROVIDER_CODE} from '@vio/core/src/offer/business/provider'
import {OfferVariant} from '@vio/core/src/offer/types/OfferVariant'

interface Props {
  isCheapest: boolean
  isBofhOffer?: boolean
  isGreatDealOffer?: boolean
}

export const getOfferVariant = ({
  /** Whether this offer is the cheapest in the current list */
  isCheapest,
  isBofhOffer,
  isGreatDealOffer
}: Props): OfferVariant => {
  if (isCheapest) {
    if (isGreatDealOffer) return OfferVariant.GreatDeal
    if (isBofhOffer) return OfferVariant.OnlyOnVio
    return OfferVariant.BestDeal
  }
  return OfferVariant.Popular
}

/**
 * Determines whether this offer should carry the Vio branding overlay on
 * the SRP and AP — i.e. the current brand shows Vio-branded offers because
 * it does not own branded offers itself (BoB partner brands do; Vio does
 * not overlay its own brand on its own offers).
 */
export const shouldOfferBeBranded = ({
  offerIntermediaryProviderCode,
  isBookOnBrand,
  hasBrandedOffers
}: {
  offerIntermediaryProviderCode: string
  isBookOnBrand: boolean
  hasBrandedOffers: boolean
}): boolean => {
  return (
    isBookOnBrand &&
    offerIntermediaryProviderCode === VIO_INTERMEDIARY_PROVIDER_CODE &&
    hasBrandedOffers === false
  )
}
